import type React from "react";

type Props = {
  label: string;
  onClick?: () => void;
  href?: string;
  className?: string;
};

export const GarageCTAButton: React.FC<Props> = ({ label, onClick, href, className = "" }) => {
  const baseClasses = `bg-primary hover:bg-primary-500 text-white w-full py-3 px-5 rounded mt-3 font-base font-bold block text-center ${className}`;
  if (href) {
    return (
      <a className={baseClasses} href={href} title={label}>
        {label}
      </a>
    );
  }

  return (
    <button type="button" className={baseClasses} onClick={onClick}>
      {label}
    </button>
  );
};
